module.exports = __webpack_public_path__ + "img/bg_poster_title.ee3a714c.png";